import jsCookie from 'js-cookie'
import $ from 'jquery'

let cookieManagement = {
    cookiePolicyLink: HTMLElement,
    cookieBanner: HTMLElement,
    cookieBannerSeeMoreButton: HTMLElement,
    cookieBannerSeeMorePanel: HTMLElement,
    cookiePreferencesCookieName: "CookiePrefs",
    cookiePreferencesCookie: Object,
    gaCookieAllowedCheckbox: HTMLInputElement,
    saveCookiePreferencesButton: HTMLButtonElement,
    acceptAllCookiesButton: HTMLElement,

    Init: function () {
        const moduleContext = this;

        moduleContext.cookiePolicyLink = document.querySelector(".cookie-policy-link");
        moduleContext.cookieBanner = document.querySelector("#cookie-warning");
        moduleContext.cookieBannerSeeMoreButton = document.querySelector("#cookie-banner-see-more-link");
        moduleContext.cookieBannerSeeMorePanel = document.querySelector(".cookie-preferences");
        moduleContext.gaCookieAllowedCheckbox = document.querySelector("#ga-cookie-allowed");
        moduleContext.saveCookiePreferencesButton = document.querySelector("#save-cookie-preferences");
        moduleContext.acceptAllCookiesButton = document.querySelector("#cookie-banner-accept-all-button");
        moduleContext.GetCookiePreferencesCookie();
        moduleContext.PopulatePreferencesCheckboxes();
        moduleContext.LoadCookieWarningBanner();

        //Assign click events
        if (moduleContext.cookiePolicyLink !== undefined && moduleContext.cookiePolicyLink !== null) {
            moduleContext.AssignCookiePolicyLinkClickEvent();
        }
        if (moduleContext.saveCookiePreferencesButton !== undefined &&
            moduleContext.saveCookiePreferencesButton !== null) {
            moduleContext.AssignSaveCookiePreferencesClickEvent();
        }
        if (moduleContext.cookieBannerSeeMoreButton !== undefined && moduleContext.cookieBannerSeeMoreButton !== null) {
            moduleContext.AssignSeeMoreButtonClickEvent();
        }
        if (moduleContext.acceptAllCookiesButton !== undefined && moduleContext.acceptAllCookiesButton !== null) {
            moduleContext.AssignAcceptAllCookiesButtonClickEvent();
        }
    },
    AssignCookiePolicyLinkClickEvent: function () {
        const moduleContext = this;
        moduleContext.cookiePolicyLink.addEventListener("click",
            function () {
                moduleContext.TriggerCookieBanner(true);
            }
        );
    },
    AssignSaveCookiePreferencesClickEvent: function () {
        const moduleContext = this;
        moduleContext.saveCookiePreferencesButton.addEventListener("click",
            function () {
                moduleContext.GetCookiePreferencesOnSave();
                moduleContext.SavePreferencesCookie();
            }
        );
    },
    AssignSeeMoreButtonClickEvent: function () {
        const moduleContext = this;
        moduleContext.cookieBannerSeeMoreButton.addEventListener("click",
            function () {
                moduleContext.TriggerCookieMoreInfoPanel();
            }
        );
    },
    AssignAcceptAllCookiesButtonClickEvent: function () {
        const moduleContext = this;
        moduleContext.acceptAllCookiesButton.addEventListener("click",
            function () {
                moduleContext.SetAcceptAllCookiePreferencesCookieObject();
                moduleContext.PopulatePreferencesCheckboxes();
                moduleContext.SavePreferencesCookie();
            }
        );
    },
    TriggerCookieBanner: function (show) {
        const moduleContext = this;
        if (show) {
            $(moduleContext.cookieBanner).slideDown();
        } else {
            $(moduleContext.cookieBanner).slideUp();

            //Reset checkboxes to ensure their state matches that of the preferences cookie (if set)
            moduleContext.GetCookiePreferencesCookie();
            moduleContext.PopulatePreferencesCheckboxes();
        }
    },
    TriggerCookieMoreInfoPanel: function (show) {
        const moduleContext = this;
        //Resorted to js animation as transitions on auto height aren't possible.
        if (show !== undefined) {
            if (show) {
                $(moduleContext.cookieBannerSeeMorePanel).slideDown();
            } else {
                $(moduleContext.cookieBannerSeeMorePanel).slideUp();
            }
        } else {
            $(moduleContext.cookieBannerSeeMorePanel).slideToggle();
        }
    },
    SetAcceptAllCookiePreferencesCookieObject: function () {
        const moduleContext = this;
        const cookiePreferences = {};
        cookiePreferences.ga = true;
        moduleContext.cookiePreferencesCookie = cookiePreferences;
        return cookiePreferences;
    },
    GetCookiePreferencesCookie: function () {
        const moduleContext = this;
        moduleContext.cookiePreferencesCookie = jsCookie.getJSON(moduleContext.cookiePreferencesCookieName);
    },
    LoadCookieWarningBanner: function () {
        const moduleContext = this;
        if (moduleContext.cookiePreferencesCookie === undefined) {
            moduleContext.TriggerCookieBanner(true);
        }
    },
    PopulatePreferencesCheckboxes: function () {
        const moduleContext = this;
        if (moduleContext.cookiePreferencesCookie !== undefined) {
            if (moduleContext.cookiePreferencesCookie.ga === false) {
                moduleContext.gaCookieAllowedCheckbox.checked = false;
            }
            else {
                moduleContext.gaCookieAllowedCheckbox.checked = true;
            }
        } else {
            moduleContext.gaCookieAllowedCheckbox.checked = true;
        }
    },
    GetCookiePreferencesOnSave: function () {
        const moduleContext = this;
        const cookiePreferences = {};
        cookiePreferences.ga = moduleContext.gaCookieAllowedCheckbox.checked;
        moduleContext.cookiePreferencesCookie = cookiePreferences;
        return cookiePreferences;
    },
    SavePreferencesCookie: function () {
        const moduleContext = this;
        jsCookie.set(moduleContext.cookiePreferencesCookieName, moduleContext.cookiePreferencesCookie, { expires: 365, secure: true });

        moduleContext.TidyUpExistingCookiesByPreference();

        moduleContext.TriggerCookieBanner(false);
        moduleContext.TriggerCookieMoreInfoPanel(false);
    },
    TidyUpExistingCookiesByPreference: function () {
        const moduleContext = this;
        if (moduleContext.cookiePreferencesCookie !== undefined &&
            moduleContext.cookiePreferencesCookie.ga !== true) {
            moduleContext.DisableGATracking();
        }
    },
    DisableGATracking: function () {
        if (window.gaData !== undefined) {
            if (ga !== null && ga !== undefined) {
                const gaTrackingId = ga.getAll()[0].get('trackingId');
                if (gaTrackingId !== undefined) {
                    let hostname = location.hostname;
                    if (hostname.includes("www.")) {
                        hostname = hostname.replace("www.", ".");
                    }
                    //console.log("location.hostname", hostname);
                    window['ga-disable-' + gaTrackingId] = true;
                    jsCookie.remove("_ga", { path: '/', domain: hostname, secure: true });
                    jsCookie.remove("_gid", { path: '/', domain: hostname, secure: true });
                    jsCookie.remove("_gat_" + gaTrackingId, { path: '/', domain: hostname, secure: true });
                    jsCookie.remove("_ga", { path: '/', domain: hostname, secure: false });
                    jsCookie.remove("_gid", { path: '/', domain: hostname, secure: false });
                    jsCookie.remove("_gat_" + gaTrackingId, { path: '/', domain: hostname, secure: false });
                } else {
                    console.error("Unable to fetch ga tracking id");
                }
            }
        }
    }
}
if (document.readyState !== 'loading') {
    cookieManagement.Init();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        cookieManagement.Init();
    });
}



// WEBPACK FOOTER //
// ./app/components/cookie-management/js/cookie-management.js